module.exports = __webpack_public_path__ + "static/img/20250320006.fe38664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250320006.jpg
// module id = ueX6
// module chunks = 0